// プラットフォーム固有 workaround の有効・無効を症状軸で集約する。
//
// 設計方針（`.claude/rules/no-hardcoded-context.md` 準拠）:
// - 呼び出し側は `if (isIOS)` ではなく `if (quirks.needsXxx)` と書く。
// - 将来 Android で別問題が発覚した場合は、各フラグの判定式に Android 条件を AND/OR で足すだけで済む。
// - 「特定 OS 名」がコード本体に散らない（症状軸の抽象化）。

import { isIOS, isTouchPrimary } from './platform';

export const quirks = {
  /**
   * iOS Safari/WebKit は `user-scalable=no` / `maximum-scale=1.0` を無視するため、
   * ダブルタップ・ピンチによる visual viewport ズームを JS 側で予防する必要がある。
   * 一度ズームすると JS から解除する API が存在しないため、発生予防が唯一の現実解。
   */
  needsDoubleTapSuppression: isIOS,

  /**
   * iOS は visual viewport zoom が永続化することがある（特に PWA standalone）。
   * `window.visualViewport.scale` を監視し、ユーザーへリセット案内を表示する必要がある。
   */
  needsViewportZoomRecovery: isIOS,

  /**
   * タッチ主環境では `setPointerCapture` を呼ばないと pointermove/up を取りこぼすことがある。
   * Pointer Events 仕様の推奨パターンなので、対応環境全般に適用する。
   */
  needsPointerCapture: isTouchPrimary,
} as const;
